import { DemoComunityListObject } from "pages/files/CommunityListing";
import { Link } from "react-router-dom";
import { SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type CommunityListProps = CustomComponentProps & {
    listItem: DemoComunityListObject;
};

const CommunityList = ({ listItem, className, style }: CommunityListProps) => {
    return (
        <div
            className={`community-list column is-4 ${className}`}
            style={style}
        >
            <article className="group-box">
                <div className="box-info-hover">
                    <i data-feather="heart"></i>
                    <div className="box-clock-info d-flex gap-5">
                        <SVG svg="topics" size={16} />
                        <span className="box-time">
                            {listItem.newPosts} new
                        </span>
                    </div>
                </div>
                <div
                    className="box-img has-background-image"
                    style={{
                        backgroundImage: `url('${listItem.img}')`
                    }}
                ></div>
                <div className="box-link">
                    <div
                        className="box-img--hover has-background-image"
                        style={{
                            backgroundImage: `url('${listItem.img}')`
                        }}
                    >
                        <Link
                            to={`/communities/${listItem.id}`}
                            className="w-full h-full d-block"
                        ></Link>
                    </div>
                </div>
                <div className="box-info">
                    <span className="box-category">{listItem.id}</span>
                    <h3 className="box-title white-text">
                        <Link to={`/communities/${listItem.id}`}>
                            {listItem.title}
                        </Link>
                    </h3>
                    <span className="box-members">
                        <Link to={`/communities/${listItem.id}/members`}>
                            {listItem.members} members
                        </Link>
                        {/* <div className="members-preview d-flex gap-5">
                            <div className="popover-hover first-community-popover p-relative cursor-pointer">
                                <img
                                    src={friendAvatar2}
                                    data-user-popover="1"
                                    alt=""
                                />
                                <UserPopover />
                            </div>
                            <div className="popover-hover middle-community-popover p-relative cursor-pointer">
                                <img
                                    src={friendAvatar3}
                                    data-user-popover="1"
                                    alt=""
                                />
                                <UserPopover />
                            </div>
                            <div className="popover-hover last-community-popover p-relative cursor-pointer">
                                <img
                                    src={friendAvatar4}
                                    data-user-popover="1"
                                    alt=""
                                />
                                <UserPopover />
                            </div>
                        </div> */}
                    </span>
                </div>
            </article>
        </div>
    );
};

export default CommunityList;
